import { Box, Center, Flex, Text, Divider, Heading } from "@chakra-ui/react";
import LoaderSpinner from "components/UIComponents/LoaderSpinner";
import { RequestMethod, RequestName } from "hooks/api/apiHookTypes";
import useApiRequest from "hooks/api/useApiHook";
import { useEffect, useState } from "react";

const TermsAndConditionsBlock = () => {
  const [policies, setPolicies] = useState(null);

  const { data, error } = useApiRequest({
    method: RequestMethod.GET,
    name: RequestName.TERMS_OF_USE,
  });

  useEffect(() => {
    if (data && !error) {
      setPolicies(data.data.terms_of_use);
    }
  }, [data, error]);

  // Roles, not shades. The outer panel was gray.50 / gray.800 — the page
  // ground's own value (bg.page); the cards white / gray.700 -> bg.surface;
  // the title band blue.50 / blue.700 -> brand.subtle. Elevation is the md
  // token, which is none on a dark ground (the surface step carries it).
  const bgColor = "bg.page";
  const textColor = "text.primary";
  const headerBgColor = "brand.subtle";
  const boxShadow = "md";
  const boxBgColor = "bg.surface";

  return (
    <Flex direction="column" p={8} bg={bgColor} borderRadius="md" boxShadow={boxShadow} maxW="800px" mx="auto" mt={10}>
      {policies ? (
        policies.map((policy, index) => (
          <Box mb={8} key={policy.id} p={5} bg={boxBgColor} borderRadius="md" boxShadow="base">
            <Box mb={4} p={3} bg={headerBgColor} borderRadius="md">
              <Heading fontSize="xl" fontWeight="bold" color={textColor}>
                {policy.id} {policy.title_en.replace(/^\.\s*/, '')}
              </Heading>
            </Box>
            <Text fontSize="md" lineHeight="tall" color={textColor}>
              {policy.text_en}
            </Text>
            {index < policies.length - 1 && <Divider mt={5} />}
          </Box>
        ))
      ) : (
        <Center>
          <LoaderSpinner />
        </Center>
      )}
    </Flex>
  );
};

export default TermsAndConditionsBlock;
